import { Modal, Button } from 'react-bootstrap';

interface IAlertProps {
    show: boolean;
    datechosen: string;
    alertType: 'businessDay' | 'pastDate';
    onClose: () => void;
}

const BusinessDayAlert = (props: IAlertProps) => {
    const isPastDate = props.alertType == 'pastDate';

    return (
        <Modal show={props.show} onHide={props.onClose} bsSize='medium' backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div style={{ color: '#c9372e', fontWeight: 'bold' }}>ALERT</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div style={{ color: '#c9372e', fontWeight: 'bold', marginBottom: 20, textAlign: 'center' }}>
                    <div style={{ marginBottom: 20 }}>**Invalid Date** '{props.datechosen}' —{' '}</div>
                    {isPastDate ?
                        <div style={{ marginBottom: 20 }}>Dates cannot be in the past.</div>
                        :
                        <div style={{ marginBottom: 20 }}>We are only including business days (Monday - Friday) for the<br />donation date range selection & total days calculation.</div>
                    }
                </div>

                <div style={{ textAlign: 'center' }}>
                    <strong>
                        {isPastDate ?
                            <>Please select today or a future business day.</>
                            :
                            <>Please select a business day.</>
                        }
                    </strong>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BusinessDayAlert;
